import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Award, Users, BookOpen, Heart, CheckCircle } from 'lucide-react';
import OptimizedImage from './OptimizedImage';
import { getCheckoutUrlWithUtms } from '@/lib/checkout';
const ProfessionalAboutInstructor = () => {
  const scrollToProduct = () => {
    const productSection = document.getElementById('cta');
    if (productSection) {
      productSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const professionalCredentials = ["Nutricionista há 25 anos especializada em obstetrícia", "Consultora de Lactação certificada pelo IBLCE", "Mestre em Saúde da Criança", "Especialista em Aleitamento Materno e Nutrição Clínica", "Possui mais de 15 anos de experiência na prática clínica de consultoria de amamentação.", "Pioneira na região Sul do Brasil.", "Já ajudou mais de 15 mil duplas mãe bebê com a amamentação."];
  const professionalAchievements = [{
    icon: Users,
    title: "+2.000 Profissionais Formados",
    description: "Enfermeiras, consultoras, doulas e outros profissionais capacitados"
  }, {
    icon: Award,
    title: "IBLCE Certificada",
    description: "Consultora de Lactação certificada pelo IBLCE"
  }, {
    icon: BookOpen,
    title: "Método PPS",
    description: "Criadora da metodologia mais eficaz em amamentação"
  }, {
    icon: Heart,
    title: "25 Anos de Experiência",
    description: "Especialização contínua em obstetrícia e aleitamento materno"
  }];
  return <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Conheça Sua Mentora Profissional
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Aprenda com quem tem experiência real em formar profissionais 
            de excelência em aleitamento materno
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          {/* Image */}
          <div className="text-center lg:text-left">
            <div className="relative inline-block">
              <div className="absolute inset-0 bg-primary/10 rounded-2xl transform rotate-3"></div>
              <OptimizedImage src="/lovable-uploads/cf978e16-cc7f-4926-84e7-12e94ef564c1.png" alt="Rosane Baldissera - Especialista em Formação Profissional" width={400} height={500} className="relative z-10 rounded-2xl shadow-xl" />
            </div>
          </div>

          {/* Content */}
          <div className="space-y-6">
            <div>
              <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                Rosane Baldissera
              </h3>
              <p className="text-lg text-primary font-semibold mb-4">
                IBLCE • Nutricionista Especialista • Formadora Profissional
              </p>
              <p className="text-gray-700 leading-relaxed mb-6">
                Com 25 anos de experiência em obstetrícia e especialização em aleitamento materno, 
                Rosane é reconhecida como uma das principais autoridades em formação profissional 
                na área materno-infantil no Brasil.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Criadora do revolucionário Método PPS, já capacitou mais de 2.000 profissionais 
                que hoje são referência em suas regiões, com taxa de sucesso de 95% nos 
                atendimentos especializados.
              </p>
            </div>

            {/* Professional Credentials */}
            <div className="space-y-3">
              <h4 className="text-lg font-bold text-gray-900">
                Credenciais Profissionais:
              </h4>
              {professionalCredentials.map((credential, index) => <div key={index} className="flex items-start gap-3">
                  <CheckCircle className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700">{credential}</span>
                </div>)}
            </div>

            <Button 
              size="lg" 
              className="bg-accent-ink hover:bg-accent-ink-dark text-white font-semibold px-8 py-4 rounded-xl" 
              onClick={() => window.location.href = getCheckoutUrlWithUtms('https://pay.hotmart.com/T84177472Y?off=s3ddbg8f&checkoutMode=10')}
            >
              Quero Me Aperfeiçoar com a Rosane
            </Button>
          </div>
        </div>

        {/* Professional Achievements */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {professionalAchievements.map((achievement, index) => {
          const IconComponent = achievement.icon;
          return <Card key={index} className="text-center border-none shadow-lg hover:shadow-xl transition-all duration-300 rounded-xl">
                <CardContent className="p-6">
                  <div className="bg-primary/10 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                    <IconComponent className="h-8 w-8 text-primary" />
                  </div>
                  <h4 className="text-lg font-bold text-gray-900 mb-2">
                    {achievement.title}
                  </h4>
                  <p className="text-gray-600 text-sm">
                    {achievement.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>

        {/* Professional Recognition */}
        
      </div>
    </section>;
};
export default ProfessionalAboutInstructor;